<template>
  <div name="votefriend-popup" id="votefriend-popup" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content clear-shadow">
        <div class="modal-header clearfix">
          <button type="button" class="close" @click="clearData()" data-dismiss="modal">&times;</button>
        </div>

        <div class="modal-body detail detail-responsive">
          <div class="box-body">
            <div class="col-xs-12 col-sm-5 box-card">
              <div class="list-friend-card clearfix">
                <div class="img-box">
                  <img v-if="popup.namimage" class="emp-img" :src="popup.namimage">
                  <img v-if="!popup.namimage" class="emp-img" src="../../assets/img/no_image.png">
                </div>
                <div class="name">{{ popup.namempt }}</div>
                <div class="nickname">{{ popup.nickname }}</div>
                <div class="underline"></div>
                <div class="position">{{ popup.desc_codpos }}</div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-7 box-desc">
              <div class="text-right date-box">
                <div v-show="popup.dtevote !== ''">
                  <i class="fa fa-clock-o clock-icon"></i>
                  <span class="text-time">
                    {{ dtevote }} {{ popup.timvote }}
                  </span>
                </div>
              </div>
              <div class="votebox-detail">
                <div class="votescore-label">{{ labels['VOTEFRIEND'][34] }}</div>
                <div class="rate">
                  <i class="fa fa-star" v-for="(rate, index) in stars" :class="rate" @click="toggleVote(index)" @mouseover="hoverVote(index)" @mouseout="hoverVote(0)"></i>
                </div>
                <div class="votecause-label">
                  {{ labels['VOTEFRIEND'][35] }}
                </div>
                <div class="clearfix">
                  <textarea class="form-control textarea-text" maxlength="600"
                            :class="{'input-error' : errors.has('remark')}"
                            v-validate="'required'"
                            :has-error="errors.has('remark')"
                            data-vv-value-path=""
                            data-vv-name="remark"
                            v-model="remark" ></textarea>
                </div>
                <div class="error-box">
                  <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                </div>
                <div class="footer">
                  <button type="button" class="btn" @click="clearData()" data-dismiss="modal" ref="modalPopupClose">{{ btnCancel }}</button>
                  <button type="button" class="btn btn-success" :disabled="score === 0" @click="voteSave()">{{ btnSave }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'votefriend-popup',
  data () {
    return {
      stars: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: ''
      },
      btnCancel: 'Cancel',
      btnSave: 'Vote',
      score: 0,
      hoverScore: 0,
      remark: '',
      dtevote: ''
    }
  },
  watch: {
    hoverScore (newVal) {
      for (var i in this.stars) {
        if (i <= newVal) {
          this.stars[i] = 'text-yellow'
        } else {
          if (i > this.score) {
            this.stars[i] = ''
          }
        }
      }
    },
    popup () {
      this.toggleVote(this.popup.score)
      this.remark = this.popup.remark
      this.dtevote = moment(this.popup.dtevote, 'DD/MM/YYYY').format('ddd MM/DD')
      this.$nextTick(() => {
        this.errors.clear()
      })
    },
    'remark' () {
      this.$validator.validate('remark', this.remark).catch(e => {})
    }
  },
  methods: {
    clearData () {
      this.toggleVote(this.popup.score)
      this.remark = this.popup.remark
    },
    toggleVote (index) {
      if (isNaN(parseInt(index))) {
        index = 0
      }
      for (var i in this.stars) {
        if (i <= index) {
          this.stars[i] = 'text-yellow'
        } else {
          this.stars[i] = ''
        }
      }
      this.score = index
    },
    hoverVote (index) {
      this.hoverScore = index
    },
    voteSave () {
      this.$validator.validateAll().then(result => {
        let params = {
          codfrnid: this.popup.codfrnid,
          codempid_query: this.currentCodempid,
          score: this.score,
          remark: this.remark,
          modalPopupClose: this.$refs.modalPopupClose
        }
        this.postVotefriendSave(params)
      })
    }
  },
  props: [ 'labels', 'popup', 'postVotefriendSave', 'currentCodempid', 'pcDisp' ]
}
</script>
<style lang="scss" scope>
  #votefriend-popup {
    .modal-content {
      background: none;
    }

    .modal-dialog {
      border-radius: 10px;
    }

    .box-card {
      height: 405px;
      background: #ebebeb;
      padding: 50px 0;
      border-radius: 0 0 0 10px;
      box-shadow: 0px 4px 6px rgba(0,0,0,0.3);

      @media (max-width: 768px) {
        border-radius: 0;
      }
    }

    .box-desc {
      height: 405px;
      background: #FFF;
      padding: 10px 20px;
      border-radius: 0 0 10px 0;
      box-shadow: 4px 4px 6px rgba(0,0,0,0.3);

      @media (max-width: 768px) {
        border-radius: 0;
      }
    }

    .date-box {
      height: 20px;

      .clock-icon {
        padding: 5px;
        font-size: 20px;
        color: #3887c9;
      }

      .text-time {
        font-family: 'db_helvethaicamon_x85_blk';
        font-size: 20px;
        color: #48b84f;
      }
    }

    .date-text {
      font-weight: bolder;
    }

    .votebox-detail {
      padding: 30px;

      @media (max-width: 768px) {
        padding: 15px;
      }
    }

    .votescore-label {
      font-family: 'db_helvethaicamon_x85_blk';
      font-size: 26px;
      color: #444;
    }

    .rate i {
      margin: 5px;
      font-size: 36px;
      color: #d7d7d7;
      cursor: pointer;

      @media (max-width: 768px) {
        font-size: 28px;
      }
    }

    .votecause-label {
      padding: 15px 0 0;
      font-family: 'db_helvethaicamon_x85_blk';
      font-size: 26px;
      color: #444;
    }

    .textarea-text {
      border-radius: 10px;
      padding: 10px;
      border-color: #ccc;
    }

    .error-box {
      font-family: 'db_helvethaicamon_x85_blk';
      height: 20px;
    }

    .footer button {
      font-family: 'db_helvethaicamon_x85_blk';
      font-size: 24px;
      line-height: 28px;
      padding: 6px 20px;
      height: 40px;
      border-radius: 5px;
    }

    .text-yellow {
      color: #FFCF28 !important;
    }

    .btn-success {
      color: #fff;
      background-color: #43ac6a;
      border-color: #3c9a5f;
    }
    .btn-success:focus,
    .btn-success.focus {
      color: #fff;
      background-color: #358753;
      border-color: #183e26;
    }
    .btn-success:hover {
      color: #fff;
      background-color: #358753;
      border-color: #2b6e44;
    }
    .btn-success:active,
    .btn-success.active,
    .open > .dropdown-toggle.btn-success {
      color: #fff;
      background-color: #358753;
      border-color: #2b6e44;
    }
    .btn-success:active:hover,
    .btn-success.active:hover,
    .open > .dropdown-toggle.btn-success:hover,
    .btn-success:active:focus,
    .btn-success.active:focus,
    .open > .dropdown-toggle.btn-success:focus,
    .btn-success:active.focus,
    .btn-success.active.focus,
    .open > .dropdown-toggle.btn-success.focus {
      color: #fff;
      background-color: #2b6e44;
      border-color: #183e26;
    }
    .btn-success:active,
    .btn-success.active,
    .open > .dropdown-toggle.btn-success {
      background-image: none;
    }
    .btn-success.disabled:hover,
    .btn-success[disabled]:hover,
    fieldset[disabled] .btn-success:hover,
    .btn-success.disabled:focus,
    .btn-success[disabled]:focus,
    fieldset[disabled] .btn-success:focus,
    .btn-success.disabled.focus,
    .btn-success[disabled].focus,
    fieldset[disabled] .btn-success.focus {
      background-color: #43ac6a;
      border-color: #3c9a5f;
    }
    .btn-success .badge {
      color: #43ac6a;
      background-color: #fff;
    }

    .modal-header {
      background: #3887c9;
      border-radius: 10px 10px 0 0;
      padding: 20px;
      border-bottom: none;
      .close {
        width: 30px;
        height: 30px;
        display: inline-block;
        // position: absolute;
        // top: 24px;
        // right: 24px;
        // transform: translate(50%, -50%);
        border-radius: 100%;
        background: #fff;
        color: #498ebf;
        font-size: 34px;
      }
    }

    .modal-body {
      margin: 0;
      padding: 0;
      .box-body {
        padding: 0;
      }
    }

    .list-friend-card {
      width: 100%;
      float: left;
      padding: 0;
      cursor: pointer;
      position: relative;

      .img-box {
        width: 200px;
        margin: 9px auto 10px;
        .emp-img {
          width: 100%;
          border-radius: 50%;
        }
      }
      .name {
        font-family: 'db_helvethaicamon_x85_blk';
        font-size: 24px;
        color: #3887c8;
        text-align: center;
      }
      .nickname {
        font-family: 'db_helvethaicamon_x85_blk';
        font-size: 18px;
        color: #3887c8;
        text-align: center;
        margin: -5px 0 0 0;
      }
      .underline {
        width: 25%;
        margin: 0 auto;
        border-bottom: 1px solid #3887c8;
      }
      .position {
        font-family: 'db_helvethaicamon_x85_blk';
        font-size: 18px;
        color: #56bd5b;
        text-align: center;
        margin: 5px 0 0 0;
      }
    }

    .footer {
      margin-top: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// popup.vue?019d8882